import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as IconStyle } from "../../../../../icons/16x16/edit.svg";
import { ReactComponent as IconImage } from "../../../../../icons/16x16/image.svg";

import "./style.scss";

interface Props {
  disableStyles?: boolean;
  openTab?: "photos" | "styles";
  onClick: (tab: "photos" | "styles") => void;
}
const EditionPanelTabs: FunctionComponent<Props> = ({
  disableStyles = false,
  openTab = "styles",
  onClick,
}) => {
  const intl = useIntl();

  return (
    <div className="EditionPanelTabs">
      <button
        type="button"
        className={classNames("EditionPanelTabs-item", {
          "EditionPanelTabs-item--active": openTab === "photos",
        })}
        onClick={() => onClick("photos")}
      >
        <IconImage />
        {intl.formatMessage({ id: "kustom_Customization_photos" })}
      </button>
      <button
        type="button"
        className={classNames("EditionPanelTabs-item", {
          "EditionPanelTabs-item--active": openTab === "styles",
          "EditionPanelTabs-item--disabled": disableStyles,
        })}
        onClick={() => onClick("styles")}
      >
        <IconStyle />
        {intl.formatMessage({ id: "kustom_PageEditionPanel_styles" })}
      </button>
    </div>
  );
};

export default EditionPanelTabs;
